import { useQuery } from "@tanstack/react-query";

import {
  type KardexFilters,
  type KardexRow,
  kardexService,
} from "~/services/wms/kardexService";

/**
 * Hook to get the WMS Kardex (stock ledger) with filters.
 * Rows come pre-ordered from the RPC so the running balance stays
 * monotonic per (bodega, producto) — do not re-sort downstream.
 */
export function useKardex(filters: KardexFilters) {
  return useQuery<KardexRow[], Error>({
    queryKey: ["wms-kardex", filters],
    queryFn: () => kardexService.getKardex(filters),
    staleTime: 30000,
  });
}
